<template>
  <div class="reorganize-tree-transactions">
    <template v-if="filteredTransactions.length">
      <div class="reorganize-tree-transactions__header">
        <span>New transactions:</span>
      </div>
      <TransitionRoot ref="listRef" as="div" class="reorganize-tree-transactions__list">
        <TransitionChild
          v-for="(transaction, index) in filteredTransactions"
          :key="index"
          as="template"
          enter="transition-transform ease-linear duration-300"
          enter-from="scale-0 opacity-0"
          enter-to="scale-100 opacity-100"
        >
          <ReorganizeTreeTransactionsItem :transaction @delete="handleDelete(index)" />
        </TransitionChild>
      </TransitionRoot>
    </template>
    <div v-else class="reorganize-tree-transactions__empty">
      No transactions to add
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, useTemplateRef } from 'vue'
import { TransitionChild, TransitionRoot } from '@headlessui/vue'

import { AnalyticsField, TransactionClass } from '@types'

import ReorganizeTreeTransactionsItem from './ReorganizeTreeTransactionsItem.vue'
import { computed } from 'vue'

type Props = {
  transactions: TransactionClass[]
}

type Emits = {
  delete: [index: number]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

defineExpose({
  scrollToBottom: () => {
    nextTick(() => {
      listRef.value?.$el?.scrollTo?.({
        top: listRef.value.$el.scrollHeight,
        behavior: 'smooth',
      })
    })
  },
})

const listRef = useTemplateRef('listRef')

const filteredTransactions = computed(() => props.transactions.filter(transaction => transaction.entry1().value?.account_id !== AnalyticsField.REPO_ROOT))

const handleDelete = (index: number) => emit('delete', index)
</script>

<style scoped>
.reorganize-tree-transactions {
  @apply h-full;
  @apply flex flex-col gap-2;
  @apply flex-auto;
  @apply overflow-hidden;

  &__header {
    @apply min-h-10;
    @apply flex items-center justify-between;
    @apply px-2 py-1;
    @apply bg-body-dark;
    @apply rounded-md;
    @apply text-xs font-medium;
    @apply uppercase;
  }

  &__header-buttons {
    @apply flex items-center gap-2;
  }

  &__list {
    @apply sm:min-w-[640px];
    @apply flex flex-col gap-2;
    @apply overflow-y-auto;
  }

  &__empty {
    @apply flex items-center justify-center;
    @apply flex-auto;
    @apply text-center;
    @apply text-sm;
    @apply text-light-text;
  }
}
</style>
